module.exports = __webpack_public_path__ + "static/media/harikrushn.85891c5d.jpg";